import { memo } from 'react'
import { replace } from 'connected-react-router'

import { useMutation } from '@tanstack/react-query'

import Routes from '@tabeeb/routes'
import { useDispatch } from '@tabeeb/store'
import { onAddErrorNotification, onAddSuccessNotification } from '@tabeeb/modules/notification/actions'
import { AnnouncementScope } from '@tabeeb/modules/articles/enums'
import { useApi } from '@tabeeb/modules/shared/utils/API'

import AnnouncementEditorPage from '../AnnouncementEditorPage'

const AnnouncementCreateTenantPage: React.FC = () => {
  const dispatch = useDispatch()

  const { articleServiceApi: api } = useApi()

  const createTenantAnnouncementMutation = useMutation({
    mutationFn: api.announcements.createTenantAnnouncementAsync,
    onSuccess: () => {
      dispatch(onAddSuccessNotification({ message: 'Announcement successfully created' }))
      dispatch(replace(Routes.announcements))
    },
    onError: () => {
      dispatch(onAddErrorNotification({ message: 'Failed to create announcement' }))
    },
  })

  return (
    <AnnouncementEditorPage
      title='Create tenant announcement'
      scope={AnnouncementScope.Tenant}
      onSubmit={createTenantAnnouncementMutation.mutate}
    />
  )
}

export default memo(AnnouncementCreateTenantPage)
